import { useTopic } from "repositories/hooks/useTopic";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { isClient } from "shared/utils";
import Script from "next/script";
import { OverlayBanner } from "./organisms/OverlayBanner";

export const ColumnPageNavigation = () => {
  const { query } = useRouter();
  const { topic, isLoading } = useTopic(query.id);

  useEffect(() => {
    if (isClient) {
      window.microadCompass = window.microadCompass || {};
      window.microadCompass.queue = window.microadCompass.queue || [];
      window.microadCompass.queue.push({
        spot: "e40b17cc841094e5a1e80385903791e0",
      });
    }
  }, []);

  const handleLoadMicroadScript = () => {
    if (isClient && window.microadCompass) {
      new window.microadCompass.AdInitializer().initialize();
    }
  };

  if (isLoading) return null;

  return !topic?.isContributeToConversionToMiror ? (
    <>
      <div id="e40b17cc841094e5a1e80385903791e0" />
      <Script
        type="text/javascript"
        src="//j.microad.net/js/compass.js"
        async
        onLoad={handleLoadMicroadScript}
      />
    </>
  ) : (
    <OverlayBanner />
  );
};
